import {
  saVersionListConstants,
  saVersionUploadConstants,
  saVersionDeleteConstants,
  saVersionConstants,
} from "../_redux-constants";
import { saVersionListService } from "../../_services";

function getSaVersionList(queryParams) {
  function getSaVersionListLoad() {
    return { type: saVersionListConstants.SAVERSION_LIST_LOADING };
  }
  function saVersionListSuccess(data) {
    return { type: saVersionListConstants.SAVERSION_LIST_SUCCESS, data };
  }
  function saVersionListFailure(error) {
    return { type: saVersionListConstants.SAVERSION_LIST_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(getSaVersionListLoad());
    return saVersionListService.getSaVersionList(queryParams).then(
      (data) => {
        dispatch(saVersionListSuccess(data));
      },
      (error) => {
        dispatch(saVersionListFailure(error?.toString()));
      }
    );
  };
}

function uploadSaVersion(queryParams) {
  function saVersionUploadLoad() {
    return { type: saVersionUploadConstants.SAVERSION_UPLOAD_LOADING };
  }
  function saVersionUploadSuccess(data) {
    return { type: saVersionUploadConstants.SAVERSION_UPLOAD_SUCCESS, data };
  }
  function saVersionUploadFailure(error) {
    return { type: saVersionUploadConstants.SAVERSION_UPLOAD_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(saVersionUploadLoad());
    return new Promise((resolve, reject) => {
      saVersionListService.uploadSaVersion(queryParams).then(
        (data) => {
          dispatch(saVersionUploadSuccess(data));
          resolve(data);
        },
        (error) => {
          dispatch(saVersionUploadFailure(error));
          reject(error);
        }
      );
    });
  };
}

function deleteSaVersion(queryParams) {
  function saVersionDeleteLoad() {
    return { type: saVersionDeleteConstants.SAVERSION_DELETE_LOADING };
  }
  function saVersionDeleteSuccess(data) {
    return { type: saVersionDeleteConstants.SAVERSION_DELETE_SUCCESS, data };
  }
  function saVersionDeleteFailure(error) {
    return { type: saVersionDeleteConstants.SAVERSION_DELETE_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(saVersionDeleteLoad());
    return saVersionListService.deleteSaVersion(queryParams).then(
      (data) => {
        dispatch(saVersionDeleteSuccess(data));
      },
      (error) => {
        dispatch(saVersionDeleteFailure(error?.toString()));
      }
    );
  };
}

function saVersion(queryParams) {
  function saVersionLoad() {
    return { type: saVersionConstants.SAVERSION_LOADING };
  }
  function saVersionSuccess(data) {
    return { type: saVersionConstants.SAVERSION_SUCCESS, data };
  }
  function saVersionFailure(error) {
    return { type: saVersionConstants.SAVERSION_FAILURE, error };
  }
  return (dispatch) => {
    dispatch(saVersionLoad());
    return saVersionListService.showSaVersion(queryParams).then(
      (data) => {
        dispatch(saVersionSuccess(data));
      },
      (error) => {
        dispatch(saVersionFailure(error?.toString()));
      }
    );
  };
}

export const saVersionListActions = {
  getSaVersionList,
  uploadSaVersion,
  deleteSaVersion,
  saVersion,
};
